<template>
  <svg
    v-if="name === 'plants'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    :width="size"
    stroke="currentColor"
    :height="size"
  >
    <path
      fill="currentColor"
      d="M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"
    />
  </svg>
  <svg
    v-else-if="name === 'mushrooms'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 489.4 489.4"
    :width="size"
    :height="size"
    stroke="currentColor"
  >
    <path
      fill="currentColor"
      d="M244.7,1.35C109.5,1.35,0,74.75,0,165.65s109.6,6.2,244.7,6.2s244.7,84.3,244.7-6.2C489.4,74.75,379.9,1.35,244.7,1.35z"
    />
    <path
      fill="currentColor"
      d="M319.7,199.45c-40.6-12.1-120.5-9.4-150,0L153,387.85c-4.7,53.6,37.7,100.2,91.7,100.2s96.3-46.2,91.7-100.2 L319.7,199.45z"
    />
  </svg>
  <svg
    v-else-if="name === 'animals'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    :width="size"
    :height="size"
    stroke="currentColor"
  >
    <path
      fill="currentColor"
      d="M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"
    />
  </svg>
  <svg
    v-else-if="name === 'spinner'"
    :width="size"
    :height="size"
    class="animate-spin mx-px"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      class="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      stroke-width="4"
    />
    <path
      class="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
    <path
      d="M12.2727273,0 L12.0551293,0.00415858315 C9.09536893,0.117479633 6.72727273,2.53254848 6.72727273,5.5 L6.727,7.199 L5,7.2 C4.44771525,7.2 4,7.64771525 4,8.2 L4,11.8 L4.00672773,11.9166211 C4.06449284,12.4139598 4.48716416,12.8 5,12.8 L6.727,12.799 L6.72727273,19 C6.72727273,19.5522847 7.17498798,20 7.72727273,20 L11.3636364,20 L11.4802575,19.9932723 C11.9775962,19.9355072 12.3636364,19.5128358 12.3636364,19 L12.363,12.799 L14.0909091,12.8 C14.5488914,12.8 14.9483407,12.4888823 15.0604728,12.0448393 L15.9695637,8.44483931 L15.9911964,8.33367327 C16.0723061,7.74310839 15.6132251,7.2 15,7.2 L12.363,7.199 L12.363,5.6 L15,5.6 C15.5522847,5.6 16,5.15228475 16,4.6 L16,1 C16,0.44771525 15.5522847,0 15,0 L12.2727273,0 Z M14,2 L14,3.599 L12.2727273,3.6 C11.2206027,3.6 10.3636364,4.44839671 10.3636364,5.5 L10.3636364,8.2 L10.3703641,8.31662113 C10.4281292,8.81395981 10.8508005,9.2 11.3636364,9.2 L13.716,9.2 L13.312,10.799 L11.3636364,10.8 L11.2470152,10.8067277 C10.7496766,10.8644928 10.3636364,11.2871642 10.3636364,11.8 L10.363,18 L8.727,18 L8.72727273,11.8 L8.720545,11.6833789 C8.66277989,11.1860402 8.24010857,10.8 7.72727273,10.8 L6,10.799 L6,9.2 L7.72727273,9.2 C8.27955748,9.2 8.72727273,8.75228475 8.72727273,8.2 L8.72727273,5.5 C8.72727273,3.56926564 10.3123895,2 12.2727273,2 L14,2 Z"
    />
  </svg>
  <svg
    v-else-if="name === 'close'"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      fill="currentColor"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
  <svg
    v-else-if="name === 'filter'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    :width="size"
    :height="size"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"
    />
  </svg>
  <svg
    v-else-if="name === 'layers'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
    :width="size"
    :height="size"
  >
    <path
      d="M480-118 120-398l66-50 294 228 294-228 66 50-360 280Zm0-202L120-600l360-280 360 280-360 280Zm0-280Zm0 178 230-178-230-178-230 178 230 178Z"
    />
  </svg>
  <svg
    v-else-if="name === 'chevron-up'"
    class="rotate-180"
    :width="size"
    :height="size"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path
      fill="currentColor"
      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
    />
  </svg>
  <svg
    v-else-if="name === 'chevron-down'"
    :width="size"
    :height="size"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path
      fill="currentColor"
      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
    />
  </svg>
  <svg
    v-else-if="name === 'chevron-right'"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    fill="currentColor"
    viewBox="0 -960 960 960"
  >
    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
  </svg>
  <svg
    v-else-if="name === 'chevron-left'"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    fill="currentColor"
    viewBox="0 -960 960 960"
  >
    <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z" />
  </svg>
  <svg
    v-else-if="name === 'search'"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    stroke-width="0"
    viewBox="0 0 20 20"
    :height="size"
    fill="currentColor"
  >
    <path
      d="m15.896 16.646-4.979-4.958q-.625.479-1.365.739-.74.261-1.531.261-1.959 0-3.323-1.365Q3.333 9.958 3.333 8q0-1.938 
                    1.365-3.312 1.364-1.376 3.323-1.376 1.937 0 3.302 1.365T12.688 8q0 .812-.261 1.562-.26.75-.719 1.355l4.959 4.958Zm-7.875-5.042q1.5 
                    0 2.541-1.052Q11.604 9.5 11.604 8t-1.042-2.552Q9.521 4.396 8.021 4.396q-1.521 0-2.563 1.052Q4.417 6.5 4.417 8t1.041 
                    2.552q1.042 1.052 2.563 1.052Z"
    />
  </svg>
  <svg
    v-else-if="name === 'fullscreen-exit'"
    stroke="currentColor"
    fill="currentColor"
    :width="size"
    :height="size"
    stroke-width="0"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path
      d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
    />
  </svg>
  <svg
    v-else-if="name === 'fullscreen'"
    stroke="currentColor"
    fill="currentColor"
    stroke-width="0"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path
      d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
    />
  </svg>
  <svg
    v-else-if="name === 'remove'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    :width="size"
    :height="size"
  >
    <path
      d="M7.3 20.5q-.75 0-1.275-.525Q5.5 19.45 5.5 18.7V6h-1V4.5H9v-.875h6V4.5h4.5V6h-1v12.7q0 .75-.525 1.275-.525.525-1.275.525ZM17 6H7v12.7q0 .125.088.213.087.087.212.087h9.4q.1 0 .2-.1t.1-.2ZM9.4 17h1.5V8H9.4Zm3.7 0h1.5V8h-1.5ZM7 6V19v-.3Z"
    />
  </svg>
  <svg
    v-else-if="name === 'point'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    :width="size"
    :height="size"
  >
    <path
      d="M12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175 1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138 1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175-1.35 1.35-3.175 2.137Q14.075 22 12 22Zm0-2q3.35 0 5.675-2.325Q20 15.35 20 12q0-3.35-2.325-5.675Q15.35 4 12 4 8.65 4 6.325 6.325 4 8.65 4 12q0 3.35 2.325 5.675Q8.65 20 12 20Zm0-8Z"
    />
  </svg>
  <svg
    v-else-if="name === 'line'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    :width="size"
    :height="size"
  >
    <path
      d="M15 22v-2.5L8 16H3v-6h4.3L10 6.9V2h6v6h-4.3L9 11.1v3.15l6 3V16h6v6ZM12 6h2V4h-2Zm-7 8h2v-2H5Zm12 6h2v-2h-2ZM13 5Zm-7 8Zm12 6Z"
    />
  </svg>
  <svg
    v-else-if="name === 'polygon'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    :width="size"
    :height="size"
  >
    <path
      d="m6.8 21-5.2-9 5.2-9h10.4l5.2 9-5.2 9Zm1.15-2h8.1l4.025-7-4.025-7h-8.1L3.9 12ZM12 12Z"
    />
  </svg>
  <svg
    v-else-if="name === 'visible'"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 -960 960 960"
    :width="size"
    :height="size"
  >
    <path
      d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"
    />
  </svg>
  <svg
    v-else-if="name === 'invisible'"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 -960 960 960"
    :width="size"
    :height="size"
  >
    <path
      d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z"
    />
  </svg>
  <svg
    v-else-if="name === 'draw'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    :width="size"
    :height="size"
  >
    <path
      d="M5.433 13.917l1.262-3.155A4 4 0 017.58 9.42l6.92-6.918a2.121 2.121 0 013 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 01-.65-.65z"
    />
    <path
      d="M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0010 3H4.75A2.75 2.75 0 002 5.75v9.5A2.75 2.75 0 004.75 18h9.5A2.75 2.75 0 0017 15.25V10a.75.75 0 00-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5z"
    />
  </svg>
  <svg
    v-else-if="name === 'folder'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
    :width="size"
    :height="size"
  >
    <path
      d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640v400q0 33-23.5 56.5T800-160H160Zm0-80h640v-400H447l-80-80H160v480Zm0 0v-480 480Z"
    />
  </svg>
  <svg
    v-else-if="name === 'dots-vertical'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
    :width="size"
    :height="size"
  >
    <path
      d="M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z"
    />
  </svg>
  <svg
    v-else-if="name === 'download'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
    :width="size"
    :height="size"
  >
    <path
      d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"
    />
  </svg>
  <svg
    v-else-if="name === 'target'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    :width="size"
    :height="size"
  >
    <path
      d="M12 15q1.25 0 2.125-.875T15 12q0-1.25-.875-2.125T12 9q-1.25 0-2.125.875T9 12q0 1.25.875 2.125T12 15Zm0 7q-2.075 0-3.9-.788-1.825-.787-3.175-2.137-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175 1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138 1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175-1.35 1.35-3.175 2.137Q14.075 22 12 22Zm0-2q3.35 0 5.675-2.325Q20 15.35 20 12q0-3.35-2.325-5.675Q15.35 4 12 4 8.65 4 6.325 6.325 4 8.65 4 12q0 3.35 2.325 5.675Q8.65 20 12 20Zm0-8Z"
    />
  </svg>
  <svg
    v-else-if="name === 'pin-water'"
    :width="size"
    :height="size"
    viewBox="0 0 50 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50 25C50 38.8 25 70 25 70C25 70 0 38.8 0 25C0 11.2 11.2 0 25 0C38.8 0 50 11.2 50 25Z"
      style="fill: #13c9e7"
    />
    <path
      d="M25 40.2998C33.8366 40.2998 41 33.1364 41 24.2998C41 15.4632 33.8366 8.2998 25 8.2998C16.1634 8.2998 9 15.4632 9 24.2998C9 33.1364 16.1634 40.2998 25 40.2998Z"
      style="fill: #dbf9ff"
    />
    <path
      d="M29.5004 27.9996C25.8004 27.9996 21.7004 25.8996 17.9004 23.8996C13.0004 21.2996 8.90039 19.1996 8.90039 24.2996C8.90039 33.0996 16.1004 40.2996 24.9004 40.2996C33.7004 40.2996 40.9004 33.0996 40.9004 24.2996C41.0004 15.4996 38.4004 27.9996 29.5004 27.9996Z"
      style="fill: #8fd7f7"
    />
    <path
      style="fill: #01b3e6; opacity: 0.19"
      d="M20.5004 27.9996C24.2004 27.9996 28.3004 25.8996 32.1004 23.8996C37.0004 21.2996 41.1004 19.1996 41.1004 24.2996C41.1004 33.0996 33.9004 40.2996 25.1004 40.2996C16.3004 40.2996 9.10041 33.0996 9.10041 24.2996C9.00041 15.4996 11.6004 27.9996 20.5004 27.9996Z"
    />
  </svg>
  <svg
    v-else-if="name === 'pin-water-green'"
    :width="size"
    :height="size"
    viewBox="0 0 50 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50 25C50 38.8 25 70 25 70C25 70 0 38.8 0 25C0 11.2 11.2 0 25 0C38.8 0 50 11.2 50 25Z"
      style="fill: #13e79b"
    />
    <path
      d="M25 40.2998C33.8366 40.2998 41 33.1364 41 24.2998C41 15.4632 33.8366 8.2998 25 8.2998C16.1634 8.2998 9 15.4632 9 24.2998C9 33.1364 16.1634 40.2998 25 40.2998Z"
      style="fill: #dbfff3"
    />
    <path
      d="M29.5004 27.9996C25.8004 27.9996 21.7004 25.8996 17.9004 23.8996C13.0004 21.2996 8.90039 19.1996 8.90039 24.2996C8.90039 33.0996 16.1004 40.2996 24.9004 40.2996C33.7004 40.2996 40.9004 33.0996 40.9004 24.2996C41.0004 15.4996 38.4004 27.9996 29.5004 27.9996Z"
      style="fill: #8ff7e3"
    />
    <path
      style="fill: #01e6a7; opacity: 0.19"
      d="M20.5004 27.9996C24.2004 27.9996 28.3004 25.8996 32.1004 23.8996C37.0004 21.2996 41.1004 19.1996 41.1004 24.2996C41.1004 33.0996 33.9004 40.2996 25.1004 40.2996C16.3004 40.2996 9.10041 33.0996 9.10041 24.2996C9.00041 15.4996 11.6004 27.9996 20.5004 27.9996Z"
    />
  </svg>

  <svg
    v-else-if="name === 'pin-aviary'"
    :width="size"
    :height="size"
    viewBox="0 0 50 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50 25C50 38.8 25 70 25 70C25 70 0 38.8 0 25C0 11.2 11.2 0 25 0C38.8 0 50 11.2 50 25Z"
      fill="currentColor"
    />
    <path
      d="M30.7996 37.7998C30.6996 37.6998 30.6996 37.5998 30.6996 37.5998C30.5996 37.4998 30.4996 37.2998 30.3996 37.0998C29.1996 34.8998 28.9996 34.1998 29.0996 33.9998C29.8996 33.0998 31.9996 28.1998 31.1996 27.0998C31.0996 26.9998 30.9996 26.8998 30.6996 26.7998L35.0996 24.1998L35.1996 24.0998C35.3996 23.8998 40.1996 18.2998 40.9996 12.8998C40.9996 12.6998 40.8996 12.3998 40.6996 12.2998C40.4996 12.1998 40.1996 12.2998 40.0996 12.4998L35.6996 19.0998C34.8996 20.1998 33.7996 21.3998 33.4996 21.5998H33.3996C33.1996 21.5998 32.5996 21.7998 32.4996 21.6998C32.4996 21.6998 32.4996 21.5998 32.4996 21.4998C32.6996 20.3998 33.5996 18.8998 33.5996 18.7998C33.5996 18.6998 33.6996 18.5998 33.6996 18.4998L33.3996 13.2998C33.3996 12.9998 33.1996 12.7998 32.8996 12.7998C32.5996 12.7998 32.3996 12.8998 32.3996 13.1998L31.1996 18.0998L30.4996 19.0998L27.1996 16.3998L26.1996 13.4998C26.0996 13.2998 25.8996 13.0998 25.6996 13.1998C25.4996 13.1998 25.2996 13.3998 25.1996 13.5998L24.6996 17.0998C24.6996 17.2998 24.6996 17.3998 24.7996 17.4998C24.8996 17.5998 27.5996 20.3998 28.8996 21.2998C29.6996 21.7998 30.3996 22.6998 30.3996 23.2998C30.3996 23.5998 30.0996 23.9998 29.5996 24.1998C28.1996 24.9998 25.6996 26.8998 24.1996 28.0998L22.8996 25.5998V21.3998V21.2998L22.2996 18.4998L23.6996 14.5998C23.6996 14.4998 23.6996 14.3998 23.6996 14.2998L22.4996 10.8998C22.3996 10.6998 22.1996 10.4998 21.8996 10.5998C21.6996 10.5998 21.4996 10.7998 21.4996 11.0998L21.1996 14.4998C20.7996 15.5998 20.2996 16.7998 20.0996 16.9998C19.7996 16.9998 18.6996 16.4998 17.5996 15.9998L15.3996 13.4998C15.1996 13.2998 14.9996 13.2998 14.7996 13.3998C14.5996 13.4998 14.4996 13.7998 14.4996 13.9998L15.2996 17.0998C15.2996 17.1998 15.3996 17.3998 15.4996 17.3998L19.5996 19.6998L20.1996 22.0998L19.8996 25.0998C19.7996 25.1998 19.4996 25.4998 18.7996 25.3998C17.4996 25.1998 15.1996 23.5998 15.1996 22.7998C15.0996 21.4998 13.9996 19.5998 13.6996 19.0998L13.4996 17.9998C13.4996 17.7998 13.2996 17.5998 13.0996 17.5998C12.8996 17.5998 12.6996 17.6998 12.5996 17.7998L11.6996 19.1998C11.5996 19.2998 11.5996 19.4998 11.6996 19.5998L12.6996 22.1998C12.8996 22.6998 12.9996 23.0998 13.0996 23.3998C12.7996 23.2998 12.3996 23.0998 11.9996 22.8998L9.99961 20.1998C9.79961 19.9998 9.59961 19.8998 9.39961 20.0998C9.19961 20.1998 9.09961 20.4998 9.09961 20.6998L10.2996 24.4998C10.2996 24.5998 10.3996 24.6998 10.4996 24.7998L15.2996 27.4998C15.2996 27.4998 15.3996 27.4998 15.4996 27.5998L17.6996 27.9998C17.9996 28.7998 18.5996 29.9998 19.7996 30.4998C19.1996 30.9998 18.5996 31.5998 18.4996 31.7998C18.0996 32.5998 14.8996 34.2998 14.2996 34.3998L13.9996 34.4998C13.2996 34.6998 12.0996 34.9998 11.7996 35.8998C11.3996 37.1998 11.6996 38.6998 12.5996 39.3998C13.4996 40.0998 15.1996 39.8998 16.5996 39.7998C16.9996 39.7998 17.3996 39.6998 17.5996 39.6998C17.8996 39.6998 18.9996 39.7998 19.0996 39.7998C19.1996 39.8998 19.3996 39.8998 19.5996 39.9998C19.5996 40.4998 19.6996 41.4998 19.8996 42.8998C19.8996 43.1998 20.1996 43.2998 20.3996 43.2998C20.3996 43.2998 20.3996 43.2998 20.4996 43.2998C20.7996 43.2998 20.9996 42.9998 20.8996 42.6998C20.7996 41.6998 20.6996 40.8998 20.5996 40.3998C21.3996 40.5998 22.2996 40.8998 23.3996 41.0998C23.8996 41.1998 24.3996 41.1998 24.8996 40.9998C25.7996 40.6998 26.3996 40.0998 26.5996 39.2998C26.6996 38.9998 26.4996 38.6998 26.1996 38.6998C25.8996 38.5998 25.5996 38.7998 25.5996 39.0998C25.4996 39.4998 25.1996 39.7998 24.5996 39.9998C24.2996 40.0998 23.9996 40.0998 23.6996 40.0998C21.9996 39.7998 20.5996 39.3998 19.5996 38.8998C19.1996 38.6998 17.5996 38.6998 17.5996 38.6998C17.2996 38.6998 16.8996 38.6998 16.4996 38.7998C15.3996 38.8998 13.7996 39.0998 13.1996 38.5998C12.6996 38.1998 12.3996 37.0998 12.6996 36.2998C12.7996 35.8998 13.7996 35.6998 14.1996 35.5998L14.3996 35.4998C14.8996 35.3998 18.5996 33.5998 19.1996 32.3998C19.3996 32.0998 20.9996 30.7998 21.1996 30.5998C22.4996 29.9998 23.7996 30.3998 24.9996 30.6998C25.1996 30.7998 25.3996 30.7998 25.5996 30.7998C26.3996 30.9998 27.1996 29.9998 27.6996 29.2998C27.7996 29.1998 27.8996 29.0998 27.8996 28.9998C28.3996 28.4998 28.4996 28.4998 28.6996 28.4998C29.0996 28.4998 29.4996 28.3998 30.2996 27.9998C30.2996 29.0998 28.9996 32.5998 28.2996 33.2998C27.5996 34.0998 28.3996 35.7998 29.3996 37.5998C29.4996 37.7998 29.5996 37.9998 29.6996 38.0998C29.6996 38.1998 29.7996 38.2998 29.8996 38.3998C30.0996 38.7998 30.7996 39.8998 30.7996 40.3998C30.7996 41.0998 30.8996 41.8998 30.9996 42.8998C30.9996 43.1998 31.2996 43.3998 31.4996 43.3998C31.4996 43.3998 31.4996 43.3998 31.5996 43.3998C31.8996 43.3998 32.0996 43.0998 32.0996 42.7998C31.9996 41.7998 31.8996 41.0998 31.8996 40.3998C31.7996 39.6998 31.2996 38.7998 30.7996 37.7998ZM11.0996 23.9998L10.8996 23.1998L11.1996 23.5998C11.2996 23.6998 11.2996 23.6998 11.3996 23.7998C12.2996 24.1998 13.4996 24.7998 13.5996 24.9998C13.5996 24.9998 13.4996 24.8998 13.4996 24.7998C13.6996 25.2998 13.8996 25.1998 14.0996 25.0998C14.3996 24.9998 14.4996 24.6998 14.3996 24.3998V24.2998C14.1996 23.8998 13.2996 21.2998 12.5996 19.3998V19.2998C12.9996 19.8998 13.9996 21.6998 13.9996 22.5998C14.0996 24.1998 17.0996 25.8998 18.4996 26.1998C19.8996 26.3998 20.5996 25.6998 20.7996 25.1998V25.0998L21.0996 21.8998C21.0996 21.7998 21.0996 21.7998 21.0996 21.6998L20.4996 18.9998C20.4996 18.8998 20.3996 18.6998 20.1996 18.6998L16.0996 16.3998L15.8996 15.5998L16.6996 16.4998L16.7996 16.5998C17.9996 17.1998 19.4996 17.9998 20.1996 17.6998C20.8996 17.4998 21.4996 15.7998 21.9996 14.4998V14.3998L22.0996 13.4998L22.3996 14.3998L20.9996 18.2998C20.9996 18.3998 20.9996 18.4998 20.9996 18.5998L21.5996 21.3998V25.6998C21.5996 25.7998 21.5996 25.8998 21.6996 25.8998L22.7996 28.1998C21.8996 27.4998 20.2996 26.4998 17.6996 26.3998C17.4996 26.3998 17.3996 26.4998 17.2996 26.5998L15.4996 26.1998L11.0996 23.9998ZM20.8996 29.5998C20.8996 29.5998 20.7996 29.6998 20.6996 29.7998C19.5996 29.5998 18.8996 28.5998 18.5996 27.7998C20.3996 27.9998 21.5996 28.6998 22.2996 29.2998C21.7996 29.2998 21.3996 29.3998 20.8996 29.5998ZM27.2996 28.1998C27.1996 28.2998 27.0996 28.3998 26.8996 28.5998C26.3996 29.2998 25.9996 29.6998 25.8996 29.6998C25.6996 29.6998 25.4996 29.5998 25.3996 29.5998C25.0996 29.4998 24.7996 29.3998 24.3996 29.3998C25.7996 28.2998 28.4996 26.1998 29.9996 25.3998C30.9996 24.7998 31.2996 24.0998 31.2996 23.5998C31.3996 22.1998 29.7996 20.9998 29.3996 20.6998C28.2996 19.9998 26.2996 17.7998 25.5996 17.1998L25.7996 15.9998L26.1996 17.0998C26.1996 17.1998 26.2996 17.2998 26.3996 17.2998L30.1996 20.4998C30.2996 20.5998 30.4996 20.5998 30.5996 20.5998C30.6996 20.5998 30.8996 20.4998 30.9996 20.3998L32.0996 18.7998C32.0996 18.6998 32.1996 18.6998 32.1996 18.5998L32.5996 16.8998L32.6996 18.4998C32.4996 18.8998 31.7996 20.2998 31.5996 21.2998C31.4996 21.8998 31.6996 22.2998 31.8996 22.4998C32.3996 22.9998 33.1996 22.7998 33.7996 22.6998H33.8996C34.5996 22.4998 35.8996 20.8998 36.6996 19.7998L39.1996 15.9998C37.6996 19.6998 34.9996 22.9998 34.5996 23.4998L29.9996 25.9998C29.9996 25.9998 29.8996 25.9998 29.8996 26.0998L28.3996 27.4998C28.0996 27.5998 27.7996 27.6998 27.2996 28.1998Z"
      style="fill: #ffffff"
    />
    <path
      d="M21.5 32.9994C21.5 33.2994 21.8 33.5994 22.1 33.5994C22.4 33.5994 22.7 33.2994 22.7 32.9994C22.7 32.6994 22.4 32.3994 22.1 32.3994C21.7 32.3994 21.5 32.6994 21.5 32.9994Z"
      style="fill: #ffffff"
    />
  </svg>

  <svg
    v-else-if="name === 'pin-zoo'"
    :width="size"
    :height="size"
    viewBox="0 0 50 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50 25C50 38.8 25 70 25 70C25 70 0 38.8 0 25C0 11.2 11.2 0 25 0C38.8 0 50 11.2 50 25Z"
      fill="currentColor"
    />
    <path
      d="M32.7 24.2L31.5 21.5C31.2 20.9 30.7 20.4 30 20.2C29 19.9 28 20.3 27.4 21.1L27 21.6C26.7 22 26.2 22.3 25.7 22.3H24.1C23.6 22.3 23.1 22 22.8 21.6L22.4 21.1C21.8 20.3 20.8 19.9 19.8 20.2C19.1 20.4 18.6 20.9 18.3 21.5L17.1 24.2C16.4 25.7 16.9 27.5 18.2 28.5C18.4 28.6 18.6 28.6 18.8 28.5L19.7 27.9L19.6 28.3C19.3 30 19.8 31.8 21.1 33C21.2 34.6 22.5 35.8 24.1 35.8H25.5C27.1 35.8 28.4 34.6 28.5 33C29.8 31.8 30.3 30 30 28.3L30.1 28L31 28.6C31.2 28.7 31.4 28.7 31.6 28.6C33 27.5 33.4 25.7 32.7 24.2ZM25.7 34.8H24.3C23.3 34.8 22.4 34 22.3 33.1L25 31.3L27.7 33.1C27.6 34 26.7 34.8 25.7 34.8ZM25 29.9L23.9 28.8C23.9 28.8 23.9 28.8 23.9 28.7H26.2V28.8L25 29.9ZM31.3 27.5L29.7 26.6C29.5 26.5 29.3 26.5 29.1 26.6C28.9 26.7 28.9 26.9 28.9 27.1L29.2 28.6C29.4 29.9 29 31.2 28.1 32.2L25.8 30.6L26.8 29.6C27.1 29.3 27.2 28.8 27.1 28.4C26.9 28 26.5 27.7 26.1 27.7H24C23.6 27.7 23.2 28 23 28.4C22.8 28.8 22.9 29.3 23.3 29.6L24.3 30.6L22 32.2C21.1 31.3 20.7 29.9 20.9 28.6L21.2 27.1C21.2 26.9 21.2 26.7 21 26.6C20.9 26.5 20.8 26.5 20.7 26.5C20.6 26.5 20.5 26.5 20.4 26.6L18.8 27.5C18.1 26.8 17.8 25.6 18.3 24.7L19.5 22C19.7 21.6 20 21.4 20.3 21.3C20.8 21.1 21.4 21.3 21.8 21.8L22.2 22.3C22.7 23 23.5 23.4 24.4 23.4H26C26.9 23.4 27.7 23 28.2 22.3L28.6 21.8C28.9 21.3 29.5 21.1 30.1 21.3C30.5 21.4 30.8 21.7 30.9 22L32.1 24.7C32.2 25.6 32 26.7 31.3 27.5Z"
      style="fill: #ffffff"
    />
    <path
      d="M38.9 30.1C38.3 26.8 37.1 23.6 35.9 21L37.2 18.5C37.6 17.7 37.6 16.8 37 16.1C36.5 15.4 35.6 15 34.7 15.2C33.9 15.4 33.4 15.6 33.1 15.7C32.4 14.7 31.5 14 30.4 13.6C29.2 13.1 27.8 13.1 26.6 13.5L25 14L23.3 13.4C22.1 13 20.7 13 19.5 13.5C18.4 13.9 17.5 14.7 16.8 15.6C16.5 15.5 15.9 15.2 15.2 15.1C14.3 14.9 13.4 15.2 12.9 16C12.4 16.7 12.3 17.7 12.7 18.4L14 21C12.8 23.7 11.7 26.8 11 30.1C10.6 32.3 11.7 34.6 13.8 35.6C19.7 38.5 23.6 41.2 24.5 43C24.6 43.2 24.8 43.3 25 43.3C25.2 43.3 25.4 43.2 25.5 43C26.4 41.2 30.3 38.5 36.2 35.6C38.2 34.6 39.3 32.3 38.9 30.1ZM35 16.2C35.5 16.1 36 16.3 36.3 16.7C36.6 17.1 36.6 17.6 36.4 18L35.4 19.8C34.8 18.6 34.2 17.5 33.7 16.6C34 16.5 34.5 16.3 35 16.2ZM13.6 18C13.4 17.6 13.4 17.1 13.7 16.7C14 16.3 14.5 16.1 15 16.2C15.6 16.3 16 16.5 16.3 16.6C15.8 17.5 15.2 18.6 14.6 19.8L13.6 18ZM35.7 34.7C31.7 36.7 26.8 39.4 25 41.8C23.2 39.4 18.3 36.6 14.3 34.7C12.7 33.9 11.7 32.1 12.1 30.3C13.2 24.7 15.6 19.8 17.5 16.6C18 15.7 18.9 15 19.9 14.6C20.4 14.4 21 14.3 21.6 14.3C22.1 14.3 22.6 14.4 23 14.5L24.9 15.1C25 15.1 25.1 15.1 25.2 15.1L27.1 14.5C28.1 14.2 29.2 14.2 30.2 14.6C31.2 15 32 15.7 32.6 16.6C34.5 19.8 36.9 24.7 38 30.3C38.3 32.1 37.3 33.9 35.7 34.7Z"
      style="fill: #ffffff"
    />
    <path
      d="M25.6 24.9L24.7 24.5C24.4 24.4 24.1 24.5 24 24.8C23.9 25.1 24 25.4 24.3 25.5L25.2 25.9C25.3 25.9 25.3 25.9 25.4 25.9C25.6 25.9 25.8 25.8 25.9 25.6C26 25.3 25.9 25 25.6 24.9Z"
      style="fill: #ffffff"
    />
  </svg>
  <svg
    v-else-if="name === 'current-location'"
    xmlns="http://www.w3.org/2000/svg"
    :height="size"
    :width="size"
    viewBox="0 -960 960 960"
    fill="currentColor"
  >
    <path
      d="M440-42v-80q-125-14-214.5-103.5T122-440H42v-80h80q14-125 103.5-214.5T440-838v-80h80v80q125 14 214.5 103.5T838-520h80v80h-80q-14 125-103.5 214.5T520-122v80h-80Zm40-158q116 0 198-82t82-198q0-116-82-198t-198-82q-116 0-198 82t-82 198q0 116 82 198t198 82Zm0-120q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T560-480q0-33-23.5-56.5T480-560q-33 0-56.5 23.5T400-480q0 33 23.5 56.5T480-400Zm0-80Z"
    />
  </svg>
  <svg
    v-else-if="name === 'error-circle'"
    xmlns="http://www.w3.org/2000/svg"
    :height="size"
    :width="size"
    fill="currentColor"
    viewBox="0 -960 960 960"
  >
    <path
      d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
    />
  </svg>
  <svg
    v-else-if="name === 'warning'"
    xmlns="http://www.w3.org/2000/svg"
    :height="size"
    :width="size"
    fill="currentColor"
    viewBox="0 -960 960 960"
  >
    <path
      d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z"
    />
  </svg>
  <svg
    v-else-if="name === 'warning-circle'"
    xmlns="http://www.w3.org/2000/svg"
    :height="size"
    :width="size"
    fill="currentColor"
    viewBox="0 -960 960 960"
  >
    <path
      d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
    />
  </svg>
  <svg
    v-else-if="name === 'check-circle'"
    xmlns="http://www.w3.org/2000/svg"
    :height="size"
    :width="size"
    fill="currentColor"
    viewBox="0 -960 960 960"
  >
    <path
      d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
    />
  </svg>
  <svg
    v-else-if="name === 'globe'"
    xmlns="http://www.w3.org/2000/svg"
    :height="size"
    :width="size"
    fill="currentColor"
    viewBox="0 -960 960 960"
  >
    <path
      d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-40-82v-78q-33 0-56.5-23.5T360-320v-40L168-552q-3 18-5.5 36t-2.5 36q0 121 79.5 212T440-162Zm276-102q20-22 36-47.5t26.5-53q10.5-27.5 16-56.5t5.5-59q0-98-54.5-179T600-776v16q0 33-23.5 56.5T520-680h-80v80q0 17-11.5 28.5T400-560h-80v80h240q17 0 28.5 11.5T600-440v120h40q26 0 47 15.5t29 40.5Z"
    />
  </svg>
  <svg
    v-else-if="name === 'map'"
    xmlns="http://www.w3.org/2000/svg"
    :height="size"
    :width="size"
    fill="currentColor"
    viewBox="0 -960 960 960"
  >
    <path
      d="m600-120-240-84-186 72q-20 8-37-4.5T120-170v-560q0-13 7.5-23t20.5-15l212-72 240 84 186-72q20-8 37 4.5t17 33.5v560q0 13-7.5 23T812-192l-212 72Zm-40-98v-468l-160-56v468l160 56Zm80 0 120-40v-474l-120 46v468Zm-440-10 120-46v-468l-120 40v474Zm440-458v468-468Zm-320-56v468-468Z"
    />
  </svg>
  <svg
    v-else-if="name === 'legend'"
    xmlns="http://www.w3.org/2000/svg"
    :height="size"
    :width="size"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      d="M8.0001 19.0002V17.0002H20.0001V19.0002H8.0001ZM8.0001 13.0002V11.0002H20.0001V13.0002H8.0001ZM8.0001 7.00024V5.00024H20.0001V7.00024H8.0001ZM4.0001 20.0002C3.4501 20.0002 2.97926 19.8044 2.5876 19.4127C2.19593 19.0211 2.0001 18.5502 2.0001 18.0002C2.0001 17.4502 2.19593 16.9794 2.5876 16.5877C2.97926 16.1961 3.4501 16.0002 4.0001 16.0002C4.5501 16.0002 5.02093 16.1961 5.4126 16.5877C5.80426 16.9794 6.0001 17.4502 6.0001 18.0002C6.0001 18.5502 5.80426 19.0211 5.4126 19.4127C5.02093 19.8044 4.5501 20.0002 4.0001 20.0002Z"
    />
    <path d="M2 14V10H6V14H2Z" />
    <path d="M2 8L4 4L6 8H2Z" />
  </svg>
  <svg
    v-else-if="name === 'clock'"
    xmlns="http://www.w3.org/2000/svg"
    :height="size"
    viewBox="0 -960 960 960"
    :width="size"
    fill="currentColor"
  >
    <path
      d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q133 0 226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160Z"
    />
  </svg>
  <svg
    v-else-if="name === 'pin'"
    xmlns="http://www.w3.org/2000/svg"
    :height="size"
    viewBox="0 -960 960 960"
    :width="size"
    fill="currentColor"
  >
    <path
      d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z"
    />
  </svg>
</template>

<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps({
  name: {
    type: String,
    default: "",
    required: true,
  },
  text: {
    type: String,
    default: "",
  },
  size: {
    type: Number,
    default: 16,
  },
});

const name = computed(() => props.name);

const size = computed(() => {
  return props.size || 16;
});
</script>
